import { Component, OnInit } from "@angular/core";
import { IconDefinition } from "@fortawesome/free-regular-svg-icons";
import { faChartLine, faChartBar, faChartPie, faTable } from "@fortawesome/free-solid-svg-icons";
import { Yii } from "../../../libraries/interfaces/Yii";
import { IWenji } from "../../../libraries/interfaces/IWenji";
import { EGraphType, IDashboardConfig, IDashboardConfigData } from "libraries/interfaces/i-dashboard-config";
import { DashboardDomainService } from "app_dashboard/service/dashboard-domain.service";
import { TitleService } from "../../service/title/title.service";
import { LocalizedPipe } from "libraries/pipes/localized/localized.pipe";

declare const wenji: IWenji;

interface IDashboardApp {
    name: string;
    icon: string;
}

interface INBTypeGraph {
    number: number;
    line: number;
    bar: number;
    pie: number;
}

interface IDashboardGraph {
    name: string;
    url: string;
    content: INBTypeGraph
    code: string;
}

@Component({
    selector: 'home-dashboard',
    templateUrl: './dashboard-home.component.html',
    styleUrls: [
        './dashbord-home.component.scss',
    ]
})
export class DashboardHomeComponent implements OnInit {
    public app: IDashboardApp;

    public graph: IDashboardGraph[];

    public faLine: IconDefinition = faChartLine;
    public faBar: IconDefinition = faChartBar;
    public faPie: IconDefinition = faChartPie;
    public faTable: IconDefinition = faTable;

    public noConfigErrorMsg: string = Yii.t('wui-sasha-js', "La configuration des Dashboard n'est pas définie");

    constructor(
        private readonly dashboardDomainService: DashboardDomainService,
        private readonly titleService: TitleService,
        private readonly localizedPipe: LocalizedPipe,
    ) {
    }

    public ngOnInit(): void {
        this.titleService.setTitle(wenji.dashboard.name);
        this.dashboardDomainService.getConfiguration()
            .subscribe(
                (configuration: IDashboardConfig[]): void => {
                    this.app = {
                        name: wenji.dashboard.name,
                        icon: wenji.dashboard.icon,
                    };

                    if (configuration?.length) {
                        this.graph = configuration.map((row: IDashboardConfig, index: number): IDashboardGraph => {
                            console.log(row.nameArray)
                            return {
                                name: row.nameArray?.length ?
                                    this.localizedPipe.transform(row.nameArray) :
                                    row.name,
                                url: `../../${index}`,
                                content: this.nbTypeGraph(row.data),
                                code: 'dashboardHome'
                            };
                        });
                    }
                }
            );
    }

    private nbTypeGraph(config: IDashboardConfigData[][]): INBTypeGraph {
        const data: INBTypeGraph = {
            number: 0,
            line: 0,
            bar: 0,
            pie: 0,
        };
        config.forEach((row: IDashboardConfigData[]): void => {
            row.forEach((graph: IDashboardConfigData): void => {
                switch (graph.type) {
                    case EGraphType.LINE:
                        data.line++;
                        break;
                    case EGraphType.ROTATEBAR:
                    case EGraphType.BAR:
                        data.bar++;
                        break;
                    case EGraphType.SUNBURST:
                        data.pie++;
                        break;
                    case EGraphType.NUMBER:
                        data.number++;
                        break;
                    default:
                        break;
                }
            });
        });
        return data;
    }
}
